import { useParams } from "react-router-dom";

export const AppOpenPage = () => {
  const { categoryName, subcategoryName } = useParams<{
    categoryName: string;
    subcategoryName?: string;
  }>();

  const openApp = () => {
  const deepLinkPath = subcategoryName
    ? `category/${categoryName}/${subcategoryName}`
    : categoryName
    ? `category/${categoryName}`
    : ``;

  const deepLink = `superstore://${deepLinkPath}`;

  const androidStore =
    "https://play.google.com/store/apps/details?id=com.digital.superstore.customerapp";

  const iosStore =
    "https://apps.apple.com/app/6746143317";

  const isAndroid = /android/i.test(navigator.userAgent);
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

  if (isAndroid) {
    // Android intent prevents error flash
    const intentUrl = `intent://${deepLinkPath}#Intent;scheme=superstore;package=com.digital.superstore.customerapp;S.browser_fallback_url=${encodeURIComponent(androidStore)};end`;
    globalThis.location.href = intentUrl;
    return;
  }

  if (isIOS) {
    const fallbackTimer = setTimeout(() => {
      globalThis.location.href = iosStore;
    }, 1500);

    const cancelFallback = () => clearTimeout(fallbackTimer);
    window.addEventListener("pagehide", cancelFallback, { once: true });
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") cancelFallback();
    }, { once: true });

    globalThis.location.href = deepLink;
    return;
  }

  // desktop fallback
  globalThis.location.href = androidStore;
};

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={{
          backgroundColor: '#3CDAA0',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%'
        }}>
          <img
            src={require('./logo.png')}
            alt="Superstore"
            style={styles.logo}
          />
        </div>
        

        <h1 style={styles.title}>
          Everything you want,
          just a few clicks away
        </h1>

        <p style={styles.subtitle}>
          Open this page directly in the Superstore app
        </p>

        <button
          onClick={openApp}
          style={styles.primaryButton}
        >
          Open in App
        </button>

        <p style={styles.storeText}>
          Don’t have the app? Download it below
        </p>

        <div style={styles.storeButtons}>
          <a
            href="https://play.google.com/store/apps/details?id=com.digital.superstore.customerapp"
            style={styles.secondaryButton}
          >
            Android
          </a>

          <a
            href="https://apps.apple.com/app/6746143317"
            style={styles.secondaryButton}
          >
            iOS
          </a>
        </div>

        <div style={styles.features}>
          <span>LOWEST PRICES</span>
          <span>BEST RANGE</span>
          <span>FAST DELIVERY</span>
        </div>

      </div>
    </div>
  );
};

const styles: any = {

  page: {
    height: "100vh",
    background: "#F5F7FA",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    fontFamily: "Inter, Arial, sans-serif"
  },

  card: {
    background: "#FFFFFF",
    borderRadius: "16px",
    padding: "40px",
    maxWidth: "420px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 25px 60px rgba(0,0,0,0.08)"
  },

  logo: {
    width: "160px",
    padding: 20
  },

  title: {
    fontSize: "26px",
    fontWeight: 700,
    color: "#111111",
    marginBottom: "10px",
    lineHeight: 1.3
  },

  subtitle: {
    fontSize: "16px",
    color: "#3CDAA0",
    marginBottom: "28px"
  },

  primaryButton: {
    width: "100%",
    padding: "16px",
    fontSize: "18px",
    borderRadius: "10px",
    border: "none",
    background: "#3CDAA0",
    color: "#000",
    fontWeight: 600,
    cursor: "pointer"
  },

  storeText: {
    marginTop: "20px",
    marginBottom: "10px",
    color: "#6B7280",
    fontSize: "14px"
  },

  storeButtons: {
    display: "flex",
    gap: "10px"
  },

  secondaryButton: {
    flex: 1,
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid #E5E7EB",
    textDecoration: "none",
    color: "#111111",
    fontWeight: 500
  },

  features: {
    marginTop: "28px",
    display: "flex",
    justifyContent: "space-between",
    fontSize: "12px",
    fontWeight: 700,
    color: "#3CDAA0"
  }

};